// const LOCALES = {};
(function () {
  "use strict";

  // ---------- helpers (jQuery replacements) ----------
  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $all(selector, root) {
    return Array.from((root || document).querySelectorAll(selector));
  }

  function toggleClass(el, className, force) {
    if (!el) return;
    if (typeof force === "boolean") el.classList.toggle(className, force);
    else el.classList.toggle(className);
  }

  function hasClass(el, className) {
    return !!el && el.classList.contains(className);
  }

  function serializeForm(formEl) {
    // Similar to jQuery .serialize()
    const fd = new FormData(formEl);
    const usp = new URLSearchParams();
    for (const [k, v] of fd.entries()) usp.append(k, String(v));
    return usp.toString();
  }

  function parseJSONSafe(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  // Minimal "slideUp" equivalent (animates height to 0 then hides)
  function slideUp(el, durationMs) {
    if (!el) return;
    const duration = typeof durationMs === "number" ? durationMs : 500;

    el.style.boxSizing = "border-box";
    el.style.overflow = "hidden";

    const startHeight = el.offsetHeight;
    el.style.height = startHeight + "px";
    // force reflow
    void el.offsetHeight;

    el.style.transition = `height ${duration}ms ease`;
    el.style.height = "0px";

    window.setTimeout(function () {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition");
    }, duration);
  }

  function closestMatch(target, selector) {
    if (!target) return null;
    return target.closest(selector);
  }

  // Ajax replacement returning a "jqXHR-like" object with done/fail/always
  function ajax(formObject) {
    const method = (formObject.type || "GET").toUpperCase();
    const url = formObject.url || "";
    const data = formObject.data || "";

    // Build fetch options
    const opts = {
      method,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    };

    let finalUrl = url;

    if (method === "GET") {
      const sep = finalUrl.includes("?") ? "&" : "?";
      finalUrl = data ? finalUrl + sep + data : finalUrl;
    } else {
      opts.body = data;
    }

    const handlers = { done: [], fail: [], always: [] };

    fetch(finalUrl, opts)
      .then(async (res) => {
        const contentType = res.headers.get("content-type") || "";
        const text = await res.text();

        // mimic jQuery's response shape used by the script:
        // - expects response to possibly be an object with success_message/error_message
        // - expects response.responseText on error
        const parsed =
          contentType.includes("application/json") ? parseJSONSafe(text) : null;

        if (res.ok) {
          const responseObj = parsed !== null ? parsed : text;
          handlers.done.forEach((fn) => fn(responseObj));
        } else {
          const responseObj = { status: res.status, responseText: text };
          handlers.fail.forEach((fn) => fn(responseObj));
        }
      })
      .catch((err) => {
        const responseObj = { status: 0, responseText: String(err && err.message ? err.message : err) };
        handlers.fail.forEach((fn) => fn(responseObj));
      })
      .finally(() => {
        handlers.always.forEach((fn) => fn());
      });

    return {
      done: function (fn) {
        handlers.done.push(fn);
        return this;
      },
      fail: function (fn) {
        handlers.fail.push(fn);
        return this;
      },
      always: function (fn) {
        handlers.always.push(fn);
        return this;
      }
    };
  }

  // ---------- original structure kept ----------
  const FormHandler = function (form) {
    this.SETTINGS = {
      FORM_SUBMIT_TRIGGER: ".js_formSubmit",
      FORM_RESPONSE_ELEMENT_PROCESS_CLASS: "processing",
      FORM_RESPONSE_ELEMENT_SUCCESS_CLASS: "success",
      FORM_RESPONSE_ELEMENT_ERROR_CLASS: "error",
      FORM_ROW_ERROR_CLASS: "haserror",
      RESPONSE_MESSAGE_PROCESS: LOCALES.RESPONSE_MESSAGE_PROCESS,
      RESPONSE_MESSAGE_SUCCESS: LOCALES.RESPONSE_MESSAGE_SUCCESS,
      RESPONSE_MESSAGE_ERROR: LOCALES.RESPONSE_MESSAGE_ERROR,
      RESPONSE_MESSAGE_NO_DATA: LOCALES.RESPONSE_MESSAGE_NO_DATA,
      RESPONSE_MESSAGE_SUBMIT_ERROR_404: LOCALES.RESPONSE_ERROR_404,
      RESPONSE_MESSAGE_SUBMIT_ERROR_UNKNOWN: LOCALES.RESPONSE_ERROR_UNKNOWN,
      FIELD_IS_VALID_CLASS: ".isvalid",
      FIELD_MIN_LENGTH_DEFAULT: 4,
      FIELD_MAX_LENGTH_DEFAULT: 40
    };

    // jQuery -> plain elements
    this.form = form; // HTMLFormElement
    this.formWrapper = this.form ? this.form.querySelector(":scope > .js_formWrapper") : null;
    this.formCover = this.form ? this.form.querySelector(".js_formCover") : null;
    this.formResponse = this.form ? this.form.querySelector(":scope > .js_formResponse") : null;
    this.submitButton = this.form ? this.form.querySelector('button[type="submit"]') : null;
    this.fields = [];

    this.init();
  };

  FormHandler.prototype.init = function () {
    const that = this;
    if (this.formResponse) this.formResponse.classList.add("hidden");

    // $(document).on('submit', '.js_formSubmit', ...) -> event delegation
    document.addEventListener("submit", function (event) {
      const formEl = closestMatch(event.target, that.SETTINGS.FORM_SUBMIT_TRIGGER);
      if (!formEl) return;

      event.preventDefault();

      if (that.checkFields()) {
        const formObject = {
          type: formEl.getAttribute("method"),
          url: formEl.getAttribute("action"),
          data: serializeForm(formEl)
        };
        that.submitForm(formObject);
      } else {
        that.showValidationErrorMessage();
      }
    });

    // this.form.on('change', '[data-depend-source]', ...)
    if (this.form) {
      this.form.addEventListener("change", function (event) {
        const sourceEl = closestMatch(event.target, "[data-depend-source]");
        if (!sourceEl) return;

        const sourceName = sourceEl.getAttribute("name") || "";
        const sourceValue = sourceEl.value;

        const targetElement = that.form.querySelector('[data-depend-target="' + CSS.escape(sourceName) + '"]');
        if (!targetElement) return;

        const targetValue = targetElement.getAttribute("data-depend-value");
        if (sourceValue === targetValue) {
          toggleClass(targetElement, "form-group--disabled", false);
        } else {
          toggleClass(targetElement, "form-group--disabled", true);
        }
      });
    }

    this.setMandatoryFields();
  };

  FormHandler.prototype.setMandatoryFields = function () {
    const that = this;
    if (!this.form) return;

    const requiredFields = $all("[required]", this.form);

    requiredFields.forEach(function (fieldEl, index) {
      const fieldName = fieldEl.getAttribute("name");
      that.fields[index] = { fieldName: fieldName, isValid: false };

      // $(this).on('blur input', ...)
      fieldEl.addEventListener("blur", function () {
        that.validateField(fieldEl);
      });
      fieldEl.addEventListener("input", function () {
        that.validateField(fieldEl);
      });
    });

    // original code had: this.submitButton.prop('disabled'); (no-op)
    // expected behavior: disable submit if there are mandatory fields
    if (that.fields.length > 0) {
      this.disableSubmitButton();
    }
  };

  FormHandler.prototype.validateField = function (inputElement) {
    // inputElement is a DOM element, not jQuery
    const fieldName = inputElement.getAttribute("name");
    const fieldType = inputElement.getAttribute("type");
    const minLength = parseInt(
      inputElement.getAttribute("minlength") ? inputElement.getAttribute("minlength") : this.SETTINGS.FIELD_MIN_LENGTH_DEFAULT,
      10
    );
    const maxLength = parseInt(
      inputElement.getAttribute("maxlength") ? inputElement.getAttribute("maxlength") : this.SETTINGS.FIELD_MAX_LENGTH_DEFAULT,
      10
    );

    // _.findIndex replacement
    const index = this.fields.findIndex(function (f) {
      return f.fieldName === fieldName;
    });

    const validator = inputElement.getAttribute("data-validator")
      ? inputElement.getAttribute("data-validator")
      : fieldType;

    const inputValue = inputElement.value;
    var validationMessage = false;

    if (inputValue !== "" && inputValue.length >= minLength && inputValue.length <= maxLength) {
      if (validator === "email") {
        validationMessage = this.validators.validateEmail(inputValue);
      } else if (validator === "zipcode") {
        validationMessage = this.validators.validateZipCode(inputValue);
      } else if (validator === "tel") {
        validationMessage = this.validators.validatePhone(inputValue);
      } else if (validator === "iban") {
        validationMessage = this.validators.validateIBAN(inputValue);
      } else if (validator === "decimal") {
        validationMessage = this.validators.validateDecimal(inputValue);
      } else if (validator === "digits") {
        validationMessage = this.validators.validateDigits(inputValue);
      }
    } else if (inputValue !== "" && inputValue.length < minLength) {
      validationMessage = LOCALES.VALIDATION_MIN_LENGTH;
    } else {
      console.log("mandatory");
      validationMessage = LOCALES.VALIDATION_MANDATORY;
    }

    console.log(validationMessage);

    const parent = inputElement.parentElement;

    if (validationMessage) {
      if (parent && !hasClass(parent, this.SETTINGS.FORM_ROW_ERROR_CLASS)) {
        // append hint span
        const hint = document.createElement("span");
        hint.className = "form-input-hint";
        hint.textContent = validationMessage;
        parent.appendChild(hint);
      }
      if (parent) toggleClass(parent, this.SETTINGS.FORM_ROW_ERROR_CLASS, true);
      if (index >= 0) this.fields[index].isValid = false;
    } else {
      if (parent) toggleClass(parent, this.SETTINGS.FORM_ROW_ERROR_CLASS, false);

      // inputElement.next('.form-input-hint').remove();
      // jQuery's next('.class') checks immediate next sibling; replicate:
      const next = inputElement.nextElementSibling;
      if (next && next.classList.contains("form-input-hint")) {
        next.remove();
      } else if (parent) {
        // fallback: remove any hint inside parent
        const anyHint = parent.querySelector(".form-input-hint");
        if (anyHint) anyHint.remove();
      }

      if (index >= 0) this.fields[index].isValid = true;
      this.checkForm();
    }

    function parseValuesIntoString(string, obj) {
      const vars = string.match(/\$([a-zA-Z0-9]+)\$/g);
      for (const i in vars) {
        if (obj[vars[i].replace(/\$/g, "")]) {
          string = string.replace(vars[i], obj[vars[i].replace(/\$/g, "")]);
        }
      }
      return string;
    }
  };

  FormHandler.prototype.checkFields = function () {
    // _.findIndex replacement
    const index = this.fields.findIndex(function (f) {
      return f.isValid === false;
    });
    return index === -1;
  };

  FormHandler.prototype.checkForm = function () {
    if (this.checkFields()) {
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  };

  FormHandler.prototype.validators = {
    validateEmail: function (inputValue) {
      const validateExpression = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      if (!validateExpression.test(inputValue)) {
        return LOCALES.VALIDATION_EMAIL;
      }
    },

    validateZipCode: function (inputValue) {
      const validateExpression = /^[0-9]{5}$/i;
      if (!validateExpression.test(inputValue)) {
        return LOCALES.VALIDATION_ZIP;
      }
    },

    validatePhone: function (inputValue) {
      const validateExpression = /^[0-9+ -/]+$/i;
      if (!validateExpression.test(inputValue)) {
        return LOCALES.VALIDATION_TEL;
      }
    },

    validateIBAN: function (inputValue) {
      const validateExpression = /^DE([0-9a-zA-Z]\s?){20}$/i;
      if (!validateExpression.test(inputValue)) {
        return LOCALES.VALIDATION_IBAN;
      }
    },

    validateDigits: function (inputValue) {
      const validateExpression = /^\d+$/i;
      if (!validateExpression.test(inputValue)) {
        return LOCALES.VALIDATION_DIGITS;
      }
    },

    validateDecimal: function (inputValue) {
      const validateExpression = /^\s*-?[1-9]\d*(\.\d{1,2})?\s*$/,
        message = "Bitte den Wert als Euro-Cent Betrag eingeben!";
      if (!validateExpression.test(inputValue)) {
        return message;
      }
    }
  };

  FormHandler.prototype.submitForm = function (formObject) {
    const that = this;

    showCover();

    // $.ajax(formObject) -> ajax(formObject)
    const request = ajax(formObject);

    request.done(function (response) {
      // response may be object (json) or string
      if (response && typeof response === "object" && "success_message" in response) {
        processResponseSuccess(response.success_message);
      } else if (response && typeof response === "object" && "error_message" in response) {
        processValidationErrors(response.error_message);
      } else {
        // If backend returns plain string or unknown object
        processResponseError({ responseText: typeof response === "string" ? response : JSON.stringify(response) });
      }
    });

    request.fail(function (response) {
      processResponseError(response);
    });

    request.always(function () {
      window.setTimeout(function () {
        hideCover();
      }, 1000);
    });

    function processResponseSuccess(response) {
      that.form.reset();

      // that.formWrapper.slideUp(500);
      slideUp(that.formWrapper, 500);

      toggleClass(that.formResponse, "hidden", false);
      toggleClass(that.formResponse, that.SETTINGS.FORM_RESPONSE_ELEMENT_SUCCESS_CLASS, true);
      toggleClass(that.formResponse, that.SETTINGS.FORM_RESPONSE_ELEMENT_ERROR_CLASS, false);

      that.showResponseSuccessMessage(response);
    }

    function processResponseError(response) {
      toggleClass(that.formResponse, "hidden", false);
      toggleClass(that.formResponse, that.SETTINGS.FORM_RESPONSE_ELEMENT_SUCCESS_CLASS, false);
      toggleClass(that.formResponse, that.SETTINGS.FORM_RESPONSE_ELEMENT_ERROR_CLASS, true);

      that.createResponseErrorMessage(response && response.responseText ? response.responseText : "");
    }

    function processValidationErrors(response) {
      // original: const errorFields = $.parseJSON(response.responseText);
      // In original code, response param is response.error_message (but then used as if it has responseText)
      // We'll handle both cases: if string JSON -> parse it; if object -> log it.
      let payload = null;

      if (response && typeof response === "string") {
        payload = parseJSONSafe(response) || response;
      } else if (response && typeof response === "object" && "responseText" in response) {
        payload = parseJSONSafe(response.responseText) || response.responseText;
      } else {
        payload = response;
      }

      console.log(payload);
    }

    function hideCover() {
      toggleClass(that.formCover, "processing", false);
      toggleClass(that.formResponse, "processing", false);
    }

    function showCover() {
      toggleClass(that.formCover, "processing", true);
      toggleClass(that.formResponse, "hidden", false);
      toggleClass(that.formResponse, "processing", true);
    }
  };

  FormHandler.prototype.enableSubmitButton = function () {
    if (!this.submitButton) return;
    toggleClass(this.submitButton, "button__disabled", false);
    this.submitButton.removeAttribute("disabled");
  };

  FormHandler.prototype.disableSubmitButton = function () {
    if (!this.submitButton) return;
    toggleClass(this.submitButton, "button__disabled", true);
    this.submitButton.setAttribute("disabled", "disabled");
  };

  FormHandler.prototype.showValidationErrorMessage = function () {
    this.createResponseErrorMessage(LOCALES.RESPONSE_MESSAGE_ERROR);
  };

  FormHandler.prototype.showResponseSuccessMessage = function (message) {
    this.showResponseMessage("success", message);
  };

  FormHandler.prototype.createResponseErrorMessage = function (message) {
    this.showResponseMessage("error", message);
  };

  FormHandler.prototype.showResponseMessage = function (messageClass, message) {
    if (!this.formResponse) return;
    this.formResponse.innerHTML = '<p class="hint ' + messageClass + '">' + message + "</p>";
  };

  // original init: if ($('.js_formSubmit').length > 0) ...
  const forms = $all(".js_formSubmit");
  if (forms.length > 0) {
    forms.forEach(function (formEl) {
      new FormHandler(formEl);
    });
  }
})();
